import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { useInvalidateTimeBlockNotes } from '@/api/reservations/get-time-block-notes'
import { useInvalidateTimeBlocks } from '@/api/reservations/get-time-blocks'

import { useInvalidateTimeBlockById } from './get-time-block-by-id'

export interface CreateTimeBlockNoteRequest {
  timeBlockId: number
  title: string
  noteBody: string
}

export const createTimeBlockNote = async ({ timeBlockId, ...data }: CreateTimeBlockNoteRequest) => {
  const response = await authAPI.post(`/time-block/${timeBlockId}/notes`, data)
  return response.data
}

export const useCreateTimeBlockNote = () => {
  const invalidateNotes = useInvalidateTimeBlockNotes()
  const invalidateTimeBlocks = useInvalidateTimeBlocks()
  const invalidateTimeBlock = useInvalidateTimeBlockById()

  return useMutation({
    mutationFn: createTimeBlockNote,
    onSuccess: (_, { timeBlockId }) => {
      invalidateNotes(timeBlockId)
      invalidateTimeBlocks()
      invalidateTimeBlock(timeBlockId)
    },
  })
}
